import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_OEMS: createAsyncMutation('GET_OEMS')
}

const oem = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getOEMs(store) {
            let url = api.oem
            return doAsyncGet(store, { url, mutationTypes: types.GET_OEMS })
        },
        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default oem
